export * from "./cache-tag";
export * from "./common";
export * from "./dates";
export * from "./domains";
export * from "./hook-utilities";
export * from "./is-external-scripts-disabled";
export * from "./jsx";
export * from "./route";
export * from "./rss";
export * from "./scheduler";
export * from "./youtube-thumbnail";

export function notEmpty<T>(
  this: void,
  value: boolean | null | number | string | T | undefined,
): value is Exclude<T, null | undefined> {
  return !(
    value === undefined ||
    value === null ||
    value === "" ||
    value === "0" ||
    value === 0 ||
    value === false ||
    (typeof value === "object" && Object.keys(value).length === 0)
  );
}

export const safeSetLocalStorage = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch {}
};

export function getWindow() {
  return typeof globalThis === "undefined" ? null : globalThis;
}
